import { render, staticRenderFns } from "./KrDs.vue?vue&type=template&id=59068746&scoped=true"
import script from "./KrDs.vue?vue&type=script&lang=js"
export * from "./KrDs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59068746",
  null
  
)

export default component.exports